import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  id: "dashboard",
  class: "flex"
}
const _hoisted_2 = {
  id: "rooms",
  class: "rooms flex flex-col justify-start"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Room = _resolveComponent("Room")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rooms, (room, i) => {
        return (_openBlock(), _createBlock(_component_Room, {
          key: `room-${i + 1}`,
          id: room.uuid,
          room: room,
          theme: room.color
        }, null, 8, ["id", "room", "theme"]))
      }), 128))
    ])
  ]))
}